import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
export function FinalCTASection() {
  return <section className="bg-gradient-to-b from-[#F8F8FA] to-white py-20 md:py-32 px-4" data-id="element-83">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-84">
        <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-85">
          Empezá a generar ingresos hoy
        </h2>
        <p className="text-xl md:text-2xl text-[#6B6B6B] mb-10 max-w-2xl mx-auto" data-id="element-86">
          Aprendé a crear tabletas aromáticas profesionales en menos de 24 horas
        </p>

        <a href={CART_URL} className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] hover:from-[#FF6EC7] hover:to-[#FF4DB8] text-white font-bold text-lg rounded-2xl shadow-lg shadow-pink-500/20 transition-all duration-300 hover:shadow-xl hover:shadow-pink-500/30 hover:scale-105" data-id="element-87">
          Acceder ahora
          <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-88" />
        </a>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-[#6B6B6B]" data-id="element-89">
          <span data-id="element-90">✓ Acceso inmediato</span>
          <span data-id="element-91">✓ Garantía 72hs</span>
          <span data-id="element-92">✓ Pago único</span>
        </div>
      </div>
    </section>;
}